import { NumericFormat, PatternFormat } from "react-number-format";
import { IFieldSpec } from "../form/types";

interface FieldProps {
  spec: IFieldSpec;
  value: string;
  message: string;
  onChange: (name: string, value: string) => void;
}

const Field = ({ spec, value, message, onChange }: FieldProps) => {
  const set = (next: string) => onChange(spec.name, next);
  const invalid = !!message;

  const control = () => {
    switch (spec.kind) {
      case "amount":
        return (
          <span className="fts-amount-wrap">
            <span className="fts-currency" aria-hidden="true">
              $
            </span>
            <NumericFormat
              className="fts-input fts-amount"
              value={value}
              thousandSeparator
              decimalScale={0}
              allowNegative={false}
              placeholder={spec.label}
              onValueChange={(v) => set(v.value)}
            />
          </span>
        );
      case "ssn":
        return (
          <PatternFormat
            className="fts-input"
            value={value}
            format="#########"
            mask="_"
            placeholder={spec.label}
            onValueChange={(v) => set(v.value)}
          />
        );
      case "phone":
        return (
          <PatternFormat
            className="fts-input"
            value={value}
            format="(###) ### ####"
            mask="_"
            placeholder={spec.label}
            onValueChange={(v) => set(v.value)}
          />
        );
      case "select":
        return (
          <select
            className={`fts-input fts-select${value ? "" : " fts-placeholder"}`}
            value={value}
            onChange={(e) => set(e.target.value)}
          >
            {spec.options?.map((option) => (
              <option key={option.id} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        );
      case "textarea":
        return (
          <textarea
            className="fts-input fts-textarea"
            value={value}
            rows={6}
            placeholder={spec.label}
            onChange={(e) => set(e.target.value)}
          />
        );
      case "text":
      default:
        return (
          <input
            className="fts-input"
            type="text"
            value={value}
            maxLength={1000}
            placeholder={spec.label}
            onChange={(e) => set(e.target.value)}
          />
        );
    }
  };

  return (
    <div
      className={`fts-field fts-field-${spec.name}${invalid ? " fts-invalid" : ""}`}
    >
      {control()}
      {message && (
        <span className="fts-error" role="alert">
          {message}
        </span>
      )}
    </div>
  );
};

export default Field;
